import React from 'react';
import { Link } from 'react-router-dom';
import CustomerHeader from '../../components/CustomerHeader';
import CustomerFooter from '../../components/CustomerFooter';
import { Card } from '../../components/ui/card';
import { Leaf, Award, Users, Truck } from 'lucide-react';

export default function About() {
    return (
        <div className="bg-white min-h-screen">
            <CustomerHeader />
            <section className="login-hero-bg text-white">
                <div className="max-w-[1400px] mx-auto px-4 py-14">
                    <h1 className="text-3xl sm:text-4xl font-bold">About Dharmik Gardens</h1>
                    <p className="text-white/85 mt-2 max-w-2xl">India’s trusted nursery and green services partner — delivering healthy plants and beautiful gardens across the country.</p>
                </div>
            </section>
            <section className="py-12">
                <div className="max-w-[1200px] mx-auto px-4 grid md:grid-cols-2 gap-8 items-start">
                    <div>
                        <h2 className="text-2xl font-bold">Our Story</h2>
                        <p className="text-neutral-700 mt-3">Dharmik Gardens Private Limited was founded with a simple mission: to bring the joy of gardening to every home and workplace in India. From a small nursery to a nationwide brand, we’ve stayed committed to quality plants, honest pricing, and personal service.</p>
                        <p className="text-neutral-700 mt-3">Whether you’re a plant parent starting your first collection, a business greening its office, or a wholesaler serving your community, we’re here to grow with you.</p>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        {[
                            { icon: Leaf, label: '10,000+ plants delivered', value: '🌿' },
                            { icon: Award, label: 'Nursery Business Since 2005', value: '⭐️' },
                            { icon: Users, label: 'B2B partners across India', value: '🤝' },
                            { icon: Truck, label: 'Pan-India delivery', value: '🚚' },
                        ].map(x => (
                            <Card key={x.label} className="p-5">
                                <div className="h-9 w-9 rounded-lg flex items-center justify-center" style={{ background: 'hsl(142 76% 92%)' }}><x.icon className="h-4 w-4" style={{ color: 'hsl(142 71% 30%)' }} /></div>
                                <div className="mt-3 text-sm font-medium">{x.label}</div>
                            </Card>
                        ))}
                    </div>
                </div>
            </section>
            <CustomerFooter />
        </div>
    );
}
